
// You can write more code here

/* START OF COMPILED CODE */

import EntityRelic from "../EntityRelic";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class RelicMagnet extends EntityRelic {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 74, y ?? 47);

    // boots
    const magnet = scene.add.image(0, 0, 'game-all', 'relic-magnet.png');
    magnet.scaleX = 0.5;
    magnet.scaleY = 0.5;
    this.add(magnet);

    this.magnet = magnet;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private magnet: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  protected injectMatter(target: Phaser.GameObjects.GameObject) {
    this.setSize(this.magnet.displayWidth, this.magnet.displayHeight);

    super.injectMatter(target);
  }
}

/* END OF COMPILED CODE */

// You can write more code here
